/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { useCurrentEditor, BubbleMenu } from "@tiptap/react";
import { Button, ButtonGroup, Typography } from "@mui/material";
import { ReactNode } from "react";

export const LegalbirdTipTapEditorTableBubbleMenu = () => {
  const { editor } = useCurrentEditor();

  if (!editor) {
    return null;
  }

  return (
    <BubbleMenu
      editor={editor}
      tippyOptions={{
        placement: "bottom",
        offset: [0, 16],
        maxWidth: "none",
      }}
    >
      {editor.isActive("table") && (
        <ButtonGroup size={"small"} orientation={"vertical"} variant={"contained"}>
          <Option command={() => editor.chain().focus().addColumnAfter().run()}>Spalte hinzufügen</Option>
          <Option command={() => editor.chain().focus().addRowAfter().run()}>Zeile hinzufügen</Option>
          <Option command={() => editor.chain().focus().deleteColumn().run()}>Spalte löschen</Option>
          <Option command={() => editor.chain().focus().deleteRow().run()}>Zeile löschen</Option>
          {editor.isActive("tableRow") && editor.state.selection.ranges.length > 1 && (
            <Option command={() => editor.chain().focus().mergeCells().run()}>Zellen verbinden</Option>
          )}
          {editor.isActive("tableRow") && editor.state.selection.ranges.length === 1 && (
            <Option command={() => editor.chain().focus().splitCell().run()}>Zellen teilen</Option>
          )}
          <Option command={() => editor.chain().focus().deleteTable().run()}>Tabelle löschen</Option>
          <Option
            command={() => {
              editor?.chain().toggleWrapperClass("no-borders").run();
            }}
          >
            Rahmenlinien umschalten
          </Option>
          <Option
            command={() => {
              editor?.chain().toggleWrapperClass("bottom-borders").run();
            }}
          >
            Untere Rahmenlinien umschalten
          </Option>
        </ButtonGroup>
      )}
    </BubbleMenu>
  );
};

type OptionProps = { command: () => void; children: ReactNode };

const Option = ({ command, children }: OptionProps) => {
  return (
    <Button onClick={command}>
      <Typography sx={{ textTransform: "none" }}>
        {children}
      </Typography>
    </Button>
  );
};
